import React from "react";
import Brightness7Icon from '@mui/icons-material/Brightness7';
import Brightness5Icon from '@mui/icons-material/Brightness5';
import IconButton from '@mui/material/IconButton';


export default function ThemeButton() {
    let currentTheme = localStorage.getItem('appTheme')
    const isDark = Boolean(currentTheme === 'dark');
    return (
        <React.Fragment>
            <IconButton
            >
                {isDark ? (
                    <Brightness7Icon style={{ color: 'white' }} />
                ) : (
                    <Brightness5Icon style={{ color: '#000000' }} />
                )}
            </IconButton>
            {isDark ? "Light" : "Dark"} Mode
        </React.Fragment>
    );
}
